var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SchoolSwitcher',{attrs:{"items":_vm.schools,"label":"Search for a school","prependInnerIcon":"","searchInputHandler":_vm.searchSchool,"setSelect":_vm.setSchool}})
}
var staticRenderFns = []

export { render, staticRenderFns }